export const LIST_VIEW_TYPES = {
    default: 0,
    defaultSmallImg: 1,
    defaultSmallImgAlt: 2,
    cardFeed: 3,
    cardFeedSmallImage: 4,
    cardFeedLink: 5,
    kundcase: 6,
}